import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-paymentfailure',
  templateUrl: './paymentfailure.component.html',
  styleUrls: ['./paymentfailure.component.css']
})
export class PaymentfailureComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    $(document).ready(function () {
      $("#paymentSuccessfullModel").modal({ backdrop: 'static', keyboard: false });
    });
  }

  paymentSuccessOk(){
    $("#paymentSuccessfullModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
this.router.navigate(['dashboard']);
  }


}
